import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { getVisualBuilderBasePayload } from "@src/store/slices/experienceBuilder/common/selectors/getVisualBuilderTrackingContext";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";
import { selectedVariations } from "@src/store/slices/variations";
import { mpVisualBuilderAllModsSaved } from "@src/utils/mixpanel";

export const trackAllModsSaved = createAsyncThunk<void, void>(
  "experienceBuilder/tracking/allModsSaved",
  (_, { getState }) => {
    const basePayload = getVisualBuilderBasePayload(getState());
    if (basePayload) {
      const mods = experienceBuilderSlice.selectors.getMods(getState());
      const variationId =
        experienceBuilderSlice.selectors.getVariationId(getState());
      const variationMods = mods.filter((m) => m.variationId === variationId);
      const device = experienceBuilderSlice.selectors.getDevice(getState());
      const variations = selectedVariations(getState());

      mpVisualBuilderAllModsSaved({
        ...basePayload,
        mod_count: variationMods.length,
        builder_mode: device,
        test_group_count: variations.length,
      });
    }
  }
);
